import React from 'react'
import { useTranslation } from 'react-i18next';
import { Box, Container, Grid, Typography } from '@mui/material'
import { CarouselProvider, DotGroup, Slider, Slide } from 'pure-react-carousel'

import BlurImageWrapper, { opacities } from '../../BlurImageWrapper'
import AvatarCard from '../../AvatarCard'
import { useScreenDetector } from '../../../hooks/useScreenDetector'

import trekzyHeroLight from '../../../assets/images/bg-light-t-2.png'

const DesktopTeamSection = ({ children }) => {
    const { t } = useTranslation(['aboutus', 'paths', 'components']);

    return (
        <BlurImageWrapper imageUrl={trekzyHeroLight} opacity={opacities.none}>
            <Container
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    py: '4rem'
                }}>
                <Typography
                    color="secondary.main"
                    variant="h2"
                    sx={{ mb: '1rem', fontWeight: 'bold' }}>
                    {t('ourteam-title')}
                </Typography>
                <Typography
                    variant="body1"
                    color="graytext.main"
                    sx={{
                        textAlign: 'center',
                        maxWidth: 1024
                    }}>
                    {t('ourteam-subtitle')}
                </Typography>
                <Box sx={{ mt: '2rem' }}>
                    {/* Fila 1: 1 elemento */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '3rem',
                            // mb: '3rem',
                        }}
                    >
                        {children.slice(0, 1)}
                    </Box>

                    {/* Fila 2: 3 elementos */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '3rem',
                            // mb: '3rem',
                        }}
                    >
                        {children.slice(1, 4)}
                    </Box>

                    {/* Fila 3: 3 elementos */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '3rem',
                        }}
                    >
                        {children.slice(4)}
                    </Box>
                </Box>


            </Container>
        </BlurImageWrapper>
    )
}

const MobileTeamSection = ({ children }) => {
    const { t } = useTranslation(['aboutus', 'paths', 'components']);

    return (
        <Box>
            <Container
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    mb: '2rem'
                }}>
                <Typography
                    color="secondary.main"
                    variant="subtitle"
                    sx={{ mb: '1rem', fontWeight: 'bold' }}>
                    {t('ourteam-title')}
                </Typography>
                <Typography
                    variant="body1"
                    color="graytext.main"
                    sx={{
                        textAlign: 'center',
                        maxWidth: 1024
                    }}>
                    {t('ourteam-subtitle')}
                </Typography>
            </Container>
            <CarouselProvider
                naturalSlideWidth={120}
                naturalSlideHeight={125}
                totalSlides={children.length}
                visibleSlides={1}
                currentSlide={Math.floor(children.length / 2) - 1}>
                <Slider>
                    {children.map((Child, index) => (
                        <Slide index={index} key={index}>
                            {Child}
                        </Slide>
                    ))}
                </Slider>
            </CarouselProvider>
        </Box>
    )
}

const TeamSection = () => {
    const { t } = useTranslation(['aboutus']);
    const { isMobile } = useScreenDetector()
    const Wrapper = isMobile ? MobileTeamSection : DesktopTeamSection
    return (
        <Wrapper>
            <AvatarCard
                imageUrl="Fotos_Quienes_Somos/1. Soraya Plaza (Proyectos).jpg"
                height={isMobile ? '200px' : '300px'}
                width={isMobile ? '180px' : '300px'}
                avatarName="Soraya Plaza"
                title={t('role-Projects')}
            />
            <AvatarCard
                imageUrl="Fotos_Quienes_Somos/2. Maria Laura Garcia (Marketing).jpeg"
                height={isMobile ? '200px' : '300px'}
                width={isMobile ? '180px' : '300px'}
                avatarName="Maria Laura"
                title={t('role-Marketing')}
            />
            <AvatarCard
                imageUrl="Fotos_Quienes_Somos/3. Alejandro Rivero (Desarrollo).png"
                height={isMobile ? '200px' : '300px'}
                width={isMobile ? '180px' : '300px'}
                avatarName="Alejandro Rivero"
                title={t('role-Dev')}
            />
            <AvatarCard
                imageUrl="Fotos_Quienes_Somos/4. Anibal Enriquez (Operacion).jpg"
                height={isMobile ? '200px' : '300px'}
                width={isMobile ? '180px' : '300px'}
                avatarName="Anibal Enriquez "
                title={t('role-Operations')}
            />
            <AvatarCard
                imageUrl="Fotos_Quienes_Somos/5. Dionne Tonato (Productos).jpg"
                height={isMobile ? '200px' : '300px'}
                width={isMobile ? '180px' : '300px'}
                avatarName="Dionne Tonato"
                title={t('role-Products')}
            />
            <AvatarCard
                imageUrl="Fotos_Quienes_Somos/6. Paola D'alta (Comercial).jpg"
                height={isMobile ? '200px' : '300px'}
                width={isMobile ? '180px' : '300px'}
                avatarName="Paola D'alta"
                title={t('role-Commercial')}
            />
            <AvatarCard
                imageUrl="Fotos_Quienes_Somos/7. Sofia Arroyo (Comercial).jpg"
                height={isMobile ? '200px' : '300px'}
                width={isMobile ? '180px' : '300px'}
                avatarName="Sofia Arroyo"
                title={t('role-Commercial')}
            />
        </Wrapper>
    )
}

export default TeamSection
